import React, { useEffect } from 'react';
import { Stack, Title, Loader, Text } from '@mantine/core';
import { useCampaign } from '../../context/CampaignContext';

function ComplianceCheckStep() {
  const {
    checkCompliance,
    setStep
  } = useCampaign();

  useEffect(() => {
    const runCheck = async () => {
      const passOrFail = await checkCompliance();
      if (passOrFail === 'pass') {
        setStep(5); // Final review step
      } else if (passOrFail === 'fail') {
        setStep(3); // Back to message step
      } else {
        console.error('Unexpected compliance status:', passOrFail);
      }
    };
    runCheck();
  }, [checkCompliance, setStep]);

  return (
    <Stack gap="md" align="center" justify="center" style={{ minHeight: 320 }}>
      <Title order={3}>Compliance Check</Title>
      <Loader size="lg" />
      <Text>Running compliance check on your message...</Text>
    </Stack>
  );
}

export default ComplianceCheckStep; 